import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'

import type { MediaStyles } from '../types'

const getStyles = ($styles?: Partial<Record<MediaStyles, React.CSSProperties>>) => css`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  -webkit-appearance: none;
  background: transparent;
  border: none;
  cursor: pointer;
  ${outline}
  border-radius: 6px;
  color: ${$styles?.icons?.color || 'var(--color-text-default)'};
`

export const MediaPlayerButton = styled.button<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
}>`
  ${({ $styles }) => getStyles($styles)}
`

export const MediaPlayerMotionButton = styled(motion.button)<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
}>`
  ${({ $styles }) => getStyles($styles)}
`
